
import { GraphElement } from "../graph-element.js"
import { createFromJSON } from "./help"
import Konva from "konva"

class CircleElement extends GraphElement {
  static fromJSON = createFromJSON(this)

  constructor(topology, x, y, attrs) {
    super(topology, "circle", x, y, {
      text: "圆形",
      port: true,
      ...attrs
    })
    // 底座加载完成时调用
    this.onLoad(() => {
      // 不需要显示名称
      this.label.visible(false)
      this.updatePortPosition()
    })
  }


  addKeyShape(name, attrs) {
    this.keyShape = this._createDarthNode()
    this.g.add(this.keyShape)

    setTimeout(() => {
      this.executeLoadedHook(this.keyShape)
    })
  }

  addTransformer() {
    const { storage, editor } = this.__topology
    if (!editor) return

    let tr = this.layer.findOne('#base-el-tr')
    if (!tr) {
      tr = new Konva.Transformer({
        rotateEnabled: false,
        padding: 5,
        ignoreStroke: true,
        id: 'base-el-tr'
      })
      this.layer.add(tr)
    }
    this.keyShape.on('click', () => {
      storage.select(this)
      tr.nodes([this.keyShape])
      this.layer.draw()
    })
    this.stage.on('click', (event) => {
      if (event.target === this.stage) {
        tr.nodes([])
        storage.deselect()
      }
    })

    // 变换时保持端口的相对位置
    this.keyShape.on('transform', () => {
      this.updatePortPosition()
    })
  }


  updatePortPosition() {
    const rx = this.keyShape.radius() * this.keyShape.scaleX()
    const ry = this.keyShape.radius() * this.keyShape.scaleY()
    let x = this.keyShape.x() - rx
    let y = this.keyShape.y() - ry
    let w = rx * 2
    let h = ry * 2

    this.ports.update(x, y, w, h)
  }


  _createDarthNode() {
    return new Konva.Circle({
      radius: 20,
      fill: "rgba(0,0,0,0)",
      stroke: "#2CD563",
      // 在变换时不会缩放边框
      strokeScaleEnabled: false,
    })
  }

}

export { CircleElement }
